import { render, staticRenderFns } from "./GameTopbar.vue?vue&type=template&id=75beb0c2&scoped=true&"
import script from "./GameTopbar.vue?vue&type=script&lang=js&"
export * from "./GameTopbar.vue?vue&type=script&lang=js&"
import style0 from "./GameTopbar.vue?vue&type=style&index=0&id=75beb0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75beb0c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VIcon,VSpacer})
